import React, { useCallback, useEffect, useState } from 'react';

import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { StyledLandingMenu } from './styles';
import { GradientButton } from '../../../components/molecules/gradient-button';
import { HorizontalMenu } from '../../../components/molecules/horizontal-menu';
import { useAuth } from '../../../hooks/use-auth';
import SingleLogo from '../../../theme/assets/logo/logo-vertical-v3.webp';
import { bemClassName } from '../../../utils/bem';
import { LoginModal } from '../login-modal';
import { UserMenu } from '../user-menu';

const b = bemClassName('landing-menu');

const LandingMenu = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isOpenLoginModal, setIsOpenLoginModal] = useState(false);

  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (searchParams.get('login') === 'true') {
      setIsOpenLoginModal(true);
      navigate(pathname, { replace: true });
    }
  }, [searchParams, pathname, navigate]);

  const goToOnboarding = useCallback(() => {
    navigate('/onboarding');
  }, [navigate]);

  const openLoginModal = useCallback(() => {
    setIsOpenLoginModal(true);
  }, []);

  const closeLoginModal = useCallback(() => {
    setIsOpenLoginModal(false);
  }, []);

  return (
    <StyledLandingMenu>
      <div className={b()}>
        <div className={b('left')}>
          <div className={b('left', 'inner')}>
            <HorizontalMenu
              items={[
                pathname !== '/' && { label: 'Home', link: '/' },
                pathname !== '/pricing' && { label: 'Pricing', link: '/pricing' },
                pathname !== '/about' && { label: 'About', link: '/about' },
              ].filter(Boolean)}
            />
          </div>
        </div>
        <div className={b('logo')}>
          <img src={SingleLogo} alt="Active Shape" />
          <svg viewBox="0 0 100 100">
            <polygon
              points="-4,0 104,0 130,100 -30,100"
              fill="white"
              stroke="black"
              strokeWidth="0.5"
              shapeRendering="geometricPrecision"
            />
          </svg>
        </div>
        <div className={b('right')}>
          <div className={b('right', 'inner')}>
            <HorizontalMenu
              items={
                isAuthenticated
                  ? [
                      { label: 'Dashboard', link: '/user/dashboard' },
                      { label: 'Blog', link: '/blog' },
                      {
                        content: <UserMenu />,
                      },
                    ].filter(Boolean)
                  : [
                      { label: 'Blog', link: '/blog' },
                      {
                        content: <GradientButton onClick={openLoginModal}>SIGN IN</GradientButton>,
                      },
                      {
                        content: <GradientButton onClick={goToOnboarding}>SIGN UP</GradientButton>,
                      },
                    ]
              }
            />
          </div>
        </div>
      </div>
      <LoginModal isOpen={isOpenLoginModal} onClose={closeLoginModal} />
    </StyledLandingMenu>
  );
};

export default LandingMenu;
